<template>
  <WdsTooltip v-if="isValid" :global="!fullscreen" :text="absoluteDate">
    <WdsText :text="relativeDate" />
  </WdsTooltip>
  <WdsText v-else text="-" />
</template>

<script lang="ts" setup>
import { computed, inject } from 'vue'
import moment from 'moment'
import { WdsText, WdsTooltip } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $t } from '@/composables/translation'
import { TableFullscreen } from '@/components/GraphqlDataTable/injection'

const JobLastCandidateSubmittedColumn = graphql(`
  fragment JobLastCandidateSubmittedColumn on Job {
    id
    lastCandidateSubmittedAt
  }
`)

const fullscreen = inject(TableFullscreen)

const props = defineProps<{ row: FragmentType<typeof JobLastCandidateSubmittedColumn> }>()
const column = computed(() => useFragment(JobLastCandidateSubmittedColumn, props.row))

const submittedAt = computed(() => moment(column.value.lastCandidateSubmittedAt))
const isValid = computed(
  () => !!column.value.lastCandidateSubmittedAt && submittedAt.value.isValid(),
)
const absoluteDate = computed(() => submittedAt.value.format('YYYY-MM-DD'))

const relativeDate = computed(() => {
  if (submittedAt.value.isSame(moment(), 'day')) {
    return $t('Today')
  }

  if (submittedAt.value.isSame(moment().subtract(1, 'day'), 'day')) {
    return $t('Yesterday')
  }

  return submittedAt.value.from(moment().startOf('day'))
})
</script>
